import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Grid, Box } from "@material-ui/core";

import AddressForm from "../../components/AddressForm";
import MinimumRequirements from "../../components/MinimumRequirements";
import WizardLayout from "../../components/WizardLayout";
import WizardNavigation from "../../components/WizardNavigation";

import { setErrorMessage } from "../../redux/errors";
import { mapErrorMessage } from "../../utils";
import useWizardSteps from "../../hooks/useWizardSteps";
import api from "../../api";
import "./style.scss";

export default function AddAddress() {
  const [provinces, setProvinces] = useState([]);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [nextWasRequired, setNextWasRequired] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const { token, isValidAddress, insuranceProductId } = useSelector(
    ({ auth, user, insurances }) => ({
      token: auth.token,
      isValidAddress: user.currentAddress && user.currentAddress.isValid,
      insuranceProductId:
        insurances.selected && insurances.selected.insuranceProductId,
    })
  );

  useEffect(() => {
    async function fetchProvinces() {
      try {
        const { data } = await api.get(
          `/provincia/pais/ARG/ch/PDS`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setProvinces(data);
      } catch (error) {
        dispatch(setErrorMessage(mapErrorMessage("systemError")));
        history.push(`/error`);
      }
    }
    fetchProvinces();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const nextAction = () => {
    if (isValidAddress && acceptTerms) {
      history.push("/resumen");
    } else if (isValidAddress && insuranceName === "AUTOMOTOR") {
      history.push("/resumen");
    }
    setNextWasRequired(true);
    return;
  };

  const { insuranceSelected } = useSelector(({ insurances }) => ({
    insuranceSelected: insurances.selected,
  }));

  const { insuranceName } = insuranceSelected || {};

  const stepWizard = () => {
    if (insuranceName === ("HOGAR" || "MASCOTA")) {
      return 2;
    } else if (insuranceName === "AUTOMOTOR") {
      return 4;
    } else {
      return 3;
    }
  };

  const [activeStep] = useWizardSteps(stepWizard());

  const [messageNotice] = useState(
    insuranceName === "INTEGRAL DE COMERCIO" ? (
      <span>
        ES REQUISITO PARA LA CONTRATACIÓN DE ESTE SEGURO QUE EN EL COMERCIO{" "}
        <b>NO EXISTA FABRICACIÓN NI DEPÓSITO COMO ÚNICA ACTIVIDAD</b>
      </span>
    ) : (
      <span>
        PARA CONTRATAR ESTE SEGURO,{" "}
        <b>ES REQUISITO QUE LA VIVIENDA SEA DE OCUPACIÓN PERMANENTE</b>
      </span>
    )
  );

  const legend = () => {
    if (insuranceName === "INTEGRAL DE COMERCIO") {
      return (
        <span>
          <b>Completá</b> los datos del domicilio de tu comercio
        </span>
      );
    } else if (insuranceName === "AUTOMOTOR") {
      return (
        <span>
          <b>Completá</b> los datos del domicilio que indicaste en la cotización
        </span>
      );
    } else {
      return (
        <span>
          {" "}
          <b>Completá</b> o <b>confirmá</b> los datos del domicilio que será
          asegurado
        </span>
      );
    }
  };

  const [suggestionInsurance] = useState(legend());

  return (
    <>
      <WizardLayout activeStep={activeStep} suggestion={suggestionInsurance}>
        <Grid item xs={11} sm={12} container justify='center'>
          <AddressForm
            provinces={provinces}
            nextWasRequired={nextWasRequired}
          />
          {insuranceName !== "AUTOMOTOR" && (
            <div>
              {" "}
              <div className='warning-message-container'>{messageNotice}</div>
              <MinimumRequirements
                acceptTerms={acceptTerms}
                setAcceptTerms={setAcceptTerms}
                insuranceProductId={insuranceProductId}
              />
            </div>
          )}
          <WizardNavigation nextAction={nextAction} />

          {insuranceName !== "AUTOMOTOR" && !acceptTerms && nextWasRequired && (
            <Box
              mt='16px'
              display='flex'
              justifyContent='flex-end'
              color='red'
              width='100%'
            >
              Es necesario que aceptes los terminos y condiciones para continuar
            </Box>
          )}
        </Grid>
      </WizardLayout>
    </>
  );
}
